<template>
  <div class="d-flex ms-4 ms-md-0">
    <div class="my-auto">
      <b-button
        v-b-modal.filter-sort-modal
        variant="secondary"
        type="button"
        class="px-3 mx-0 mx-md-3"
        :disabled="isLoading"
      >
        <i class="fa fa-filter" />
        <span class="d-none d-sm-inline-block ms-2">
          Filter & Sort
        </span>
        <span
          v-if="totalFilter"
          class="badge bg-danger rounded-pill position-absolute ms-2 notification-dot"
          style="top: 10px;"
        >
          {{ totalFilter }}
        </span>
      </b-button>
      <b-modal
        id="filter-sort-modal"
        title="Filter and Sort"
        size="xl"
        no-close-on-backdrop
        @shown="populateFilter"
      >
        <div class="d-flex justify-content-between">
          <div class="my-auto">
            <h5>
              Filter
            </h5>
          </div>
          <a
            href="#"
            @click="resetFilter"
          >
            Reset Filter
          </a>
        </div>
        <div class="two-column">
          <div
            v-for="(param, index) in filterParams"
            :key="index"
          >
            <b-row class="py-3">
              <b-col
                sm="4"
                class="d-flex"
                style="min-height: 40px"
              >
                <input

                  :id="`filter-checkbox-${index}`"
                  v-model="enabledFilters"
                  type="checkbox"
                  :value="param.key"
                >
                <label
                  :for="`filter-checkbox-${index}`"
                  class=" ms-2 my-auto"
                >
                  {{ param.label }}
                </label>
              </b-col>

              <b-col
                v-if="param.key == 'sector'"
                sm="8"
              >
                <v-select
                  v-model="sectorFilter"
                  :options="sectorOptions"
                  label="text"
                  multiple
                />
              </b-col>

              <b-col
                v-else-if="param.key == 'industry'"
                sm="8"
              >
                <v-select
                  v-model="industryFilter"
                  :options="industryOptions"
                  label="text"
                  multiple
                />
              </b-col>

              <b-col
                v-else-if="param.key == 'exchange'"
                sm="8"
              >
                <v-select
                  v-model="exchangeFilter"
                  :options="exchangeOptions"
                  multiple
                />
              </b-col>

              <b-col
                v-else
                sm="8"
              >
                <b-row>
                  <b-col>
                    <b-form-select
                      v-model="filter[param.key + '_cmp']"
                      :options="comparatorOptions"
                      plain
                    />
                  </b-col>
                  <b-col class="pe-0">
                    <div class="d-flex pe-3">
                      <b-form-input
                        v-model="filter[param.key + '_v1']"
                        type="number"
                      />
                      <div
                        v-if="filter[param.key + '_cmp'] == 'bw' || filter[param.key + '_cmp'] == 'os'"
                        class="d-inline-block my-auto px-2 mx-1"
                        style="width: 10px"
                      >
                        -
                      </div>
                      <div
                        v-else
                        class="d-inline-block my-auto ms-2"
                        style="width: 10px"
                      >
                        {{ param.isPercentage ? '%' : '' }}
                      </div>
                    </div>
                  </b-col>
                  <b-col
                    v-show="filter[param.key + '_cmp'] == 'bw' || filter[param.key + '_cmp'] == 'os'"
                    class="ps-0"
                  >
                    <div class="d-flex pe-3">
                      <b-form-input
                        v-model="filter[param.key + '_v2']"
                        type="number"
                      />
                      <div
                        class="d-inline-block my-auto ms-2"
                        style="width: 10px"
                      >
                        {{ param.isPercentage ? '%' : '' }}
                      </div>
                    </div>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </div>
        </div>
        <hr>
        <div class="d-flex justify-content-between">
          <div class="my-auto">
            <h5>
              Sort
            </h5>
          </div>
          <a
            href="#"
            @click="resetSort"
          >
            Reset Sort
          </a>
        </div>
        <div>
          <b-row
            v-for="i in 5"
            :key="i"
            class="py-3"
          >
            <b-col
              sm="2"
              class="d-flex"
            >
              <input
                :id="`sort-checkbox-${i}`"
                v-model="enabledSort"
                type="checkbox"
                :value="i"
              >
              <label
                :for="`sort-checkbox-${i}`"
                class="ms-2 my-auto"
              >
                Sort Priority {{ i }}
              </label>
            </b-col>
            <b-col sm="6">
              <b-form-select
                :id="`sort-priority-${i}`"
                v-model="filter['sort_priority' + i]"
                :options="sortParams"
                plain
              />
            </b-col>
            <b-col sm="4">
              <b-form-select
                :id="`sort-priority-${i}-type`"
                v-model="filter['sort_priority' + i + '_type']"
                :options="[{ text: 'Ascending', value: 'asc' }, { text: 'Descending', value: 'dsc' }]"
                plain
              />
            </b-col>
          </b-row>
        </div>
        <template #modal-footer="{ ok, cancel }">
          <b-button
            variant="danger"
            style="min-width: 80px"
            @click="cancel()"
          >
            Cancel
          </b-button>
          <b-button
            variant="primary"
            style="min-width: 80px"
            data-dismiss="modal"
            @click="doFilter"
          >
            Apply
          </b-button>
        </template>
      </b-modal>
    </div>
    <b-dropdown
      menu-class="dropdown-menu-lg dropdown-menu-end dropdown-search d-md-none"
      right
      variant="black"
      toggle-class="header-item"
    >
      <template v-slot:button-content>
        <b-button
          variant="secondary"
          type="button"
          class="d-block d-md-none px-3 mx-2 mx-md-3"
          :disabled="isLoading"
        >
          <i class="fa fa-search" />
          <span class="d-none d-sm-inline-block ms-2">
            Search
          </span>
        </b-button>
      </template>
      <div
        class="px-3"
      >
        <form
          class="app-search py-1"
          @submit.prevent
        >
          <div
            class="position-relative"
            style="min-width: 200px;"
          >
            <input
              v-model="searchKeyword"
              type="text"
              class="form-control"
              style="padding-right: 40px"
              placeholder="Search by Stock Ticker/Company Name"
              @input="handleInput"
            >
            <span class="bx bx-search-alt" />
            <div
              v-if="searchKeyword"
              class="position-absolute clear-search"
              style="top: 0px; right: 50px"
              @click="searchKeyword = null"
            >
              <span class="bx bx-x" />
            </div>
          </div>
        </form>
      </div>
    </b-dropdown>
    <form
      class="app-search d-none d-md-block"
      @submit.prevent
    >
      <div
        class="position-relative"
        style="min-width: 360px;"
      >
        <input
          v-model="searchKeyword"
          type="text"
          class="form-control"
          style="padding-right: 40px"
          placeholder="Search by Stock Ticker/Company Name"
          @input="handleInput"
        >
        <span class="bx bx-search-alt" />
        <div
          v-if="searchKeyword"
          class="position-absolute clear-search"
          style="top: 0px; right: 50px"
          @click="searchKeyword = null"
        >
          <span class="bx bx-x" />
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import {
  stockParams, industryList, sectorList, exchangeList,
} from '@/utils/constant';
import { FilterService } from '../services/local-storage';

export default {
  data() {
    return {
      stockParams,
      industryList,
      sectorList,
      exchangeList,
      selected: null,
      totalFilter: 0,
      comparatorOptions: [
        { value: 'a', text: 'Above' },
        { value: 'b', text: 'Below' },
        { value: 'ae', text: 'Above or Equals' },
        { value: 'be', text: 'Below or Equals' },
        { value: 'bw', text: 'Between' },
        { value: 'os', text: 'Outside' },
        { value: 'e', text: 'Equals' },
      ],
      filter: {
        market_cap_cmp: 'a',
        market_cap_v1: 0,
        market_cap_v2: 0,
        dividend_yield_cmp: 'a',
        dividend_yield_v1: 0,
        dividend_yield_v2: 0,
        dividend_yield_avg_5yr_cmp: 'a',
        dividend_yield_avg_5yr_v1: 0,
        dividend_yield_avg_5yr_v2: 0,
        dividend_yield_avg_10yr_cmp: 'a',
        dividend_yield_avg_10yr_v1: 0,
        dividend_yield_avg_10yr_v2: 0,
        dividend_growth_5yr_cagr_cmp: 'a',
        dividend_growth_5yr_cagr_v1: 0,
        dividend_growth_5yr_cagr_v2: 0,
        dividend_growth_10yr_cagr_cmp: 'a',
        dividend_growth_10yr_cagr_v1: 0,
        dividend_growth_10yr_cagr_v2: 0,
        dividend_growth_streak_cmp: 'a',
        dividend_growth_streak_v1: 0,
        dividend_growth_streak_v2: 0,
        earnings_payout_ratio_cmp: 'a',
        earnings_payout_ratio_v1: 0,
        earnings_payout_ratio_v2: 0,
        fcf_payout_ratio_cmp: 'a',
        fcf_payout_ratio_v1: 0,
        fcf_payout_ratio_v2: 0,
        revenue_growth_5yr_cagr_cmp: 'a',
        revenue_growth_5yr_cagr_v1: 0,
        revenue_growth_5yr_cagr_v2: 0,
        revenue_growth_10yr_cagr_cmp: 'a',
        revenue_growth_10yr_cagr_v1: 0,
        revenue_growth_10yr_cagr_v2: 0,
        eps_growth_5yr_cagr_cmp: 'a',
        eps_growth_5yr_cagr_v1: 0,
        eps_growth_5yr_cagr_v2: 0,
        eps_growth_10yr_cagr_cmp: 'a',
        eps_growth_10yr_cagr_v1: 0,
        eps_growth_10yr_cagr_v2: 0,
        fcf_growth_5yr_cagr_cmp: 'a',
        fcf_growth_5yr_cagr_v1: 0,
        fcf_growth_5yr_cagr_v2: 0,
        fcf_growth_10yr_cagr_cmp: 'a',
        fcf_growth_10yr_cagr_v1: 0,
        fcf_growth_10yr_cagr_v2: 0,
        fcf_per_share_growth_5yr_cagr_cmp: 'a',
        fcf_per_share_growth_5yr_cagr_v1: 0,
        fcf_per_share_growth_5yr_cagr_v2: 0,
        fcf_per_share_growth_10yr_cagr_cmp: 'a',
        fcf_per_share_growth_10yr_cagr_v1: 0,
        fcf_per_share_growth_10yr_cagr_v2: 0,
        fcf_to_revenue_ratio_cmp: 'a',
        fcf_to_revenue_ratio_v1: 0,
        fcf_to_revenue_ratio_v2: 0,
        roic_cmp: 'a',
        roic_v1: 0,
        roic_v2: 0,
        roic_avg_5yr_cmp: 'a',
        roic_avg_5yr_v1: 0,
        roic_avg_5yr_v2: 0,
        roic_avg_10yr_cmp: 'a',
        roic_avg_10yr_v1: 0,
        roic_avg_10yr_v2: 0,
        debt_to_ebitda_ratio_cmp: 'a',
        debt_to_ebitda_ratio_v1: 0,
        debt_to_ebitda_ratio_v2: 0,
        interest_coverage_ratio_cmp: 'a',
        interest_coverage_ratio_v1: 0,
        interest_coverage_ratio_v2: 0,
        price_to_earnings_ratio_cmp: 'a',
        price_to_earnings_ratio_v1: 0,
        price_to_earnings_ratio_v2: 0,
        price_to_fcf_ratio_cmp: 'a',
        price_to_fcf_ratio_v1: 0,
        price_to_fcf_ratio_v2: 0,
        ev_to_ebitda_ratio_cmp: 'a',
        ev_to_ebitda_ratio_v1: 0,
        ev_to_ebitda_ratio_v2: 0,
        roe_cmp: 'a',
        roe_v1: 0,
        roe_v2: 0,
        roa_cmp: 'a',
        roa_v1: 0,
        roa_v2: 0,
        debt_to_equity_ratio_cmp: 'a',
        debt_to_equity_ratio_v1: 0,
        debt_to_equity_ratio_v2: 0,
        current_ratio_cmp: 'a',
        current_ratio_v1: 0,
        current_ratio_v2: 0,
        cape_ratio_cmp: 'a',
        cape_ratio_v1: 0,
        cape_ratio_v2: 0,
        net_debt_to_ebitda_ratio_cmp: 'a',
        net_debt_to_ebitda_ratio_v1: 0,
        net_debt_to_ebitda_ratio_v2: 0,
        sort_priority1: null,
        sort_priority2: null,
        sort_priority3: null,
        sort_priority4: null,
        sort_priority5: null,
        sort_priority1_type: 'asc',
        sort_priority2_type: 'asc',
        sort_priority3_type: 'asc',
        sort_priority4_type: 'asc',
        sort_priority5_type: 'asc',
      },
      searchKeyword: null,
      delayTimer: null,
      industryFilter: [],
      sectorFilter: [],
      exchangeFilter: [],
      enabledFilters: [],
      enabledSort: [],
      enabledExchange: [],
    };
  },
  computed: {
    ...mapState('stock', {
      isLoading: (state) => state.isLoading,
    }),
    ...mapState('filter', {
      stateCurrentPage: (state) => state.currentPage,
      statePerPage: (state) => state.perPage,
    }),

    currentPage: {
      get() {
        return this.stateCurrentPage;
      },
      set(value) {
        this.$store.commit('filter/SET_PAGE', value);
      },
    },

    storageFilter() {
      return FilterService.get();
    },
    filterParams() {
      const nonFilterParams = ['symbol', 'company_name'];
      return this.stockParams.filter((param) => !nonFilterParams.includes(param.key));
    },
    sortParams() {
      const nonSortParams = ['symbol', 'company_name'];
      const sortParams = this.stockParams.filter((param) => !nonSortParams.includes(param.key));
      const arr = [{ value: null, text: 'Select Parameter', disabled: true }];
      const final = sortParams.map((param) => ({
        text: param.label,
        value: param.key,
      }));
      return arr.concat(final);
    },
    industryOptions() {
      return this.industryList.filter((item) => !this.industryFilter.includes(item));
    },
    sectorOptions() {
      return this.sectorList.filter((item) => !this.sectorFilter.includes(item));
    },
    exchangeOptions() {
      return this.exchangeList.filter((item) => !this.exchangeFilter.includes(item));
    },
    processedFilter() {
      const processedFilter = {};
      const excludedItems = ['sector', 'industry', 'exchange'];
      this.enabledFilters.forEach((item) => {
        if (!excludedItems.includes(item)) {
          const selectedParam = this.filterParams.find((param) => param.key == item);
          processedFilter[`${item}_cmp`] = this.filter[`${item}_cmp`];
          processedFilter[`${item}_v1`] = selectedParam.isPercentage ? this.filter[`${item}_v1`] / 100 : this.filter[`${item}_v1`];
          processedFilter[`${item}_v2`] = selectedParam.isPercentage ? this.filter[`${item}_v2`] / 100 : this.filter[`${item}_v2`];
        }
      });
      if (this.enabledFilters.includes('sector')) {
        processedFilter.sector = this.sectorFilter;
      }
      if (this.enabledFilters.includes('industry')) {
        processedFilter.industry = this.industryFilter;
      }
      if (this.enabledFilters.includes('exchange')) {
        processedFilter.exchange = this.exchangeFilter;
      }
      for (let i = 1; i < 6; i++) {
        if (this.enabledSort.includes(i)) {
          processedFilter[`sort_priority${i}`] = this.filter[`sort_priority${i}`];
          processedFilter[`sort_priority${i}_type`] = this.filter[`sort_priority${i}_type`];
        }
      }
      processedFilter.startswith = this.searchKeyword;
      processedFilter.page = this.currentPage;
      processedFilter.per_page = this.statePerPage;

      return processedFilter;
    },
  },
  watch: {
    statePerPage: {
      immediate: false,
      handler() {
        if (this.currentPage == 1) {
          this.getStocksData(this.processedFilter);
        } else {
          this.currentPage = 1;
        }
      },
    },
    currentPage: {
      immediate: false,
      handler() {
        this.getStocksData(this.processedFilter);
      },
    },
  },
  mounted() {
    this.loadData();
  },
  methods: {
    ...mapActions('stock', ['getStocksData']),
    ...mapActions('filter', ['saveFilter']),
    resetFilter() {
      const filterKey = this.filterParams.map((item) => item.key);
      filterKey.forEach((item) => {
        if (item != 'sector' && item != 'industry') {
          this.filter[`${item}_cmp`] = 'a';
          this.filter[`${item}_v1`] = 0;
          this.filter[`${item}_v2`] = 0;
        }
      });
      this.industryFilter = [];
      this.sectorFilter = [];
      this.exchangeFilter = [];
      this.enabledFilters = [];
    },
    resetSort() {
      for (let i = 1; i < 6; i++) {
        this.filter[`sort_priority${i}`] = null;
        this.filter[`sort_priority${i}_type`] = 'asc';
      }
      this.enabledSort = [];
    },
    handleInput() {
      clearTimeout(this.delayTimer);
      this.delayTimer = setTimeout(() => {
        if (this.currentPage == 1) {
          this.getStocksData(this.processedFilter);
        } else {
          this.currentPage = 1;
        }
        this.getStocksData(this.processedFilter);
      }, 750);
    },
    doFilter() {
      this.searchKeyword = null;
      this.totalFilter = this.enabledFilters.length;
      const filterObj = {
        data_filter: this.filter,
        enabled_filter: this.enabledFilters,
        industry: this.industryFilter,
        sector: this.sectorFilter,
        exchange: this.exchangeFilter,
        enabled_sort: this.enabledSort,
      };
      this.$toast.success('Filter Saved!', {
        position: 'top-right',
        timeout: 2000,
        closeOnClick: true,
        showCloseButtonOnHover: false,
        hideProgressBar: true,
        closeButton: 'button',
        icon: true,
        rtl: false,
      });
      FilterService.set(filterObj);
      if (this.currentPage == 1) {
        this.getStocksData(this.processedFilter);
      } else {
        this.currentPage = 1;
      }
      this.$bvModal.hide('filter-sort-modal');
    },
    populateFilter() {
      const storedFilter = FilterService.get();
      if (storedFilter.data_filter) {
        this.filter = { ...storedFilter.data_filter };
        this.industryFilter = storedFilter.industry ?? [];
        this.sectorFilter = storedFilter.sector ?? [];
        this.exchangeFilter = storedFilter.exchange ?? [];
      }
      if (storedFilter.enabled_filter) {
        this.enabledFilters = storedFilter.enabled_filter;
      }
      if (storedFilter.enabled_sort) {
        this.enabledSort = storedFilter.enabled_sort;
      }
      this.totalFilter = this.enabledFilters.length;
    },
    loadData() {
      this.populateFilter();
      this.getStocksData(this.processedFilter);
    },
  },
};

</script>

<style scoped>

.clear-search {
  cursor: pointer;
}

.notification-dot {
  padding-left: 4px;
  width: 17px;
  height: 17px;
  border-radius: 50%;
  font-size: 10px;
}

::v-deep .dropdown-search {
  margin: 0px -10px;
  background-color: #2a3042;
  border-radius: 0px;
}

@media (min-width: 991.98px) {

  ::v-deep .two-column {
    columns: 2;
    column-fill: balance;
    column-gap: 20px;
  }
}
</style>
